"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.News = void 0;
class News {
    constructor(data) {
        this.id = null;
        this.title = null;
        this.source = null;
        this.feedId = null;
        this.feedType = null;
        this.image = null;
        this.tagline = null;
        this.richContent = null;
        this.createdAt = null;
        this.updatedAt = null;
        if (data) {
            this.hydrate(data);
        }
    }
    hydrate(data) {
        for (const prop in data) {
            if (Object.prototype.hasOwnProperty.call(this, prop) && Object.prototype.hasOwnProperty.call(data, prop)) {
                this[prop] = data[prop];
            }
        }
    }
}
exports.News = News;
//# sourceMappingURL=News.js.map